// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-pages-management-workflows-WorkflowCardPage-WorkflowCardPage-module__form--gUC1t {
  flex: 1;
  min-height: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
/*# sourceMappingURL=WorkflowCardPage.module.css.map */`, "",{"version":3,"sources":["webpack://./WorkflowCardPage.module.less","webpack://./src/pages/management/workflows/WorkflowCardPage/WorkflowCardPage.module.less"],"names":[],"mappings":"AACA;EACE,OAAA;EACA,aAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;ACAF;AACA,sDAAsD","sourcesContent":["// Колонка, чтобы ToolBox2 занял только место под PageSubheader\n.form {\n  flex: 1;\n  min-height: 0;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n",".form {\n  flex: 1;\n  min-height: 0;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n/*# sourceMappingURL=WorkflowCardPage.module.css.map */"],"sourceRoot":""}]);
// Exports
export var form = `src-pages-management-workflows-WorkflowCardPage-WorkflowCardPage-module__form--gUC1t`;
export default ___CSS_LOADER_EXPORT___;
